import { render, staticRenderFns } from "./PendingReferenceGroupsView.vue?vue&type=template&id=69fe11ec&scoped=true&"
import script from "./PendingReferenceGroupsView.vue?vue&type=script&lang=js&"
export * from "./PendingReferenceGroupsView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69fe11ec",
  null
  
)

export default component.exports